import { getbadgenum } from '@/api/lawcase/lawcase'

/**
 * 消息记录
 */
const app = {
	state: {
		// 详情的角标
		badgeNum: {
			id:0,
			record: 0,
			finance: 0,
			court: 0,
			judgment: 0,
			preservation: 0,
			filelist:0,
			complain:0,
			shouan:0
		}
	},

	mutations: {
		
		/**
		 * 更改角标
		 */
		SET_BADGENUM: (state, badgeNum) => {
			state.badgeNum = badgeNum
		},
		
		// 角标+1
		incrementByLawcase:(state, type) => {
			state.badgeNum[type]++
		},
		
		// 角标-1
		descrementByLawcase:(state, type) => {
			state.badgeNum[type]--
		},
		
		// 清空数据
		emptybadgeByLawcase:(state) => {
			state.badgeNum = {
				id:0,
				record: 0,
				finance: 0,
				court: 0,
				judgment: 0,
				preservation: 0,
				complain:0,
				shouan:0
			}
		}
	},

	actions: {
		// 角标
		GetLawcaseBadgeNum({
			commit
		}, id) {
			return new Promise((resolve, reject) => {
				getbadgenum({id:id})
					.then(response => {
						commit('SET_BADGENUM', response.data)
						resolve(response)
					})
					.catch(error => {
						reject(error)
					})
			})
		}
	}
}

export default app
